import { render, staticRenderFns } from "./ProjectEventTypeDetails.vue?vue&type=template&id=11dc976c&scoped=true&"
import script from "./ProjectEventTypeDetails.vue?vue&type=script&lang=js&"
export * from "./ProjectEventTypeDetails.vue?vue&type=script&lang=js&"
import style0 from "./ProjectEventTypeDetails.vue?vue&type=style&index=0&id=11dc976c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11dc976c",
  null
  
)

export default component.exports